import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-8">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <p className="text-gray-400 text-sm">
          &copy; {new Date().getFullYear()} Fresh Chicken | Wszystkie prawa zastrzeżone.
        </p>
        
        <p className="text-gray-600 text-xs mt-1">PR</p>
      </div>
    </footer>
  );
};

export default Footer;
